import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageHeader } from 'src/components/common/page-header';
import { UserProfile } from 'src/components/user/user-profile';

export const UserProfilePage = () => {
  const { id } = useParams();

  const { t } = useTranslation(undefined, {
    keyPrefix: 'user-profile.breadcrumbs',
  });

  const breadCrumbsProps = {
    items: [{ label: t(id ? 'user-profile' : 'your-profile') }],
  };

  const title = t(id ? 'user-profile' : 'your-profile');

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      <UserProfile />
    </>
  );
};
